import React from 'react';
import {
  Bolt as ZapIcon,
  Shield as ShieldCheckIcon,
  PersonAdd as UserPlusIcon,
  Person as UserCheckIcon,
  SmartToy as BotIcon,
  AutoAwesome as SparklesIcon,
  Nightlight as MoonIcon,
} from '@mui/icons-material';
import { T, fontDisplay, fontBody } from './tokens';
import ToggleRow from './ToggleRow';
import LeadStagePanel from './templates/LeadStagePanel';

export default function AdvancedSettings({ settings, onChange }) {
  const wired = [
    { key: 'enabled', icon: ZapIcon, label: 'Auto-reply enabled', sub: 'Master switch for all default templates' },
    { key: 'duplicateReplyGuard', icon: ShieldCheckIcon, label: 'Prevent duplicate replies', sub: 'Once per contact per channel in 24 hours' },
    { key: 'createLeadOnComment', icon: UserPlusIcon, label: 'Create CRM lead on comment', sub: 'When comment auto-reply runs' },
    { key: 'createLeadOnDm', icon: UserCheckIcon, label: 'Create CRM lead on DM', sub: 'When DM auto-reply runs' },
  ];
  const comingSoon = [
    { icon: BotIcon, label: 'Stop automation after human reply', sub: 'Coming soon' },
    { icon: SparklesIcon, label: 'Enable AI fallback', sub: 'Coming soon' },
    { icon: MoonIcon, label: 'Working hours configuration', sub: 'Coming soon' },
  ];

  return (
    <div style={{ background: T.card, border: `1px solid ${T.line}`, borderRadius: 16, padding: '20px 22px' }}>
      <div style={{ fontFamily: fontDisplay, fontSize: 16, fontWeight: 600, color: T.ink, marginBottom: 4 }}>Account settings</div>
      <div style={{ fontFamily: fontBody, fontSize: 12.5, color: T.slate, marginBottom: 16 }}>
        Applies to all default templates unless overridden individually.
      </div>
      {wired.map((r, i) => (
        <div
          key={r.key}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 0',
            borderTop: i === 0 ? 'none' : `1px solid ${T.lineSoft}`,
          }}
        >
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ width: 32, height: 32, borderRadius: 9, background: '#F1F2F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <r.icon sx={{ fontSize: 15, color: T.slate }} />
            </div>
            <div>
              <div style={{ fontFamily: fontBody, fontSize: 13.5, fontWeight: 600, color: T.ink }}>{r.label}</div>
              <div style={{ fontFamily: fontBody, fontSize: 12, color: T.slateLight }}>{r.sub}</div>
            </div>
          </div>
          <ToggleRow
            label=""
            checked={!!settings[r.key]}
            disabled={r.key !== 'enabled' && !settings.enabled}
            onChange={(v) => onChange({ [r.key]: v })}
          />
        </div>
      ))}
      <div style={{ borderTop: `1px solid ${T.lineSoft}`, marginTop: 8, paddingTop: 16 }}>
        <div style={{ fontFamily: fontBody, fontSize: 12, fontWeight: 700, color: T.slate, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12 }}>
          Lead pipeline stages
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
          <div>
            <div style={{ fontFamily: fontBody, fontSize: 13, fontWeight: 600, color: T.ink, marginBottom: 8 }}>Comment flow</div>
            <LeadStagePanel templateType="comment_reply" settings={settings} onSettingsChange={onChange} compact />
          </div>
          <div>
            <div style={{ fontFamily: fontBody, fontSize: 13, fontWeight: 600, color: T.ink, marginBottom: 8 }}>Incoming DM flow</div>
            <LeadStagePanel templateType="dm_reply" settings={settings} onSettingsChange={onChange} compact />
          </div>
        </div>
      </div>
      {comingSoon.map((r) => (
        <div key={r.label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '13px 0', borderTop: `1px solid ${T.lineSoft}`, opacity: 0.45 }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <div style={{ width: 32, height: 32, borderRadius: 9, background: '#F1F2F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <r.icon sx={{ fontSize: 15, color: T.slate }} />
            </div>
            <div>
              <div style={{ fontFamily: fontBody, fontSize: 13.5, fontWeight: 600, color: T.ink }}>{r.label}</div>
              <div style={{ fontFamily: fontBody, fontSize: 12, color: T.slateLight }}>{r.sub}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
